export function creditCard(number) {
  const parity = number.length % 2
  const sum = number.split('')
    .map(it => parseInt(it))
    .reduceRight((prev, current, i) => {
      current *= (i % 2 === parity ? 2 : 1)
      current -= 9 * (current > 9)
      return prev + current
    }, 0)

  return sum % 10 === 0
}

export function cpf(number) {
  if (number.length !== 11) {
    return false
  }

  const firstDigit = parseInt(number[9])
  const secondDigit = parseInt(number[10])
  const code = number.substring(0, 9).split('').map(it => parseInt(it))
  if (new Set(code).size === 1) {
    return false
  }

  const firstSum = code.reduce((prev, current, i) => prev + current * (10 - i), 0) * 10
  const firstRemainder = firstSum % 11 === 10 ? 0 : firstSum % 11
  if (firstRemainder !== firstDigit) {
    return false
  }

  const secondSum = code.concat(firstDigit).reduce((prev, current, i) => prev + current * (11 - i), 0) * 10
  const secondRemainder = secondSum % 11 === 10 ? 0 : secondSum % 11
  return secondRemainder === secondDigit
}

export function ifoodEmail(value) {
  return /.{2}@ifood\.com\.br$/.test(value) === true
}

export function strongPassword(v) {
  return /^(?=.*\d)(?=.*[a-z]).{8,30}$/.test(v)
}
